import React from "react"
import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  IconButton,
  Stack,
  Autocomplete,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  Popover,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  ListItemIcon,
  FormControlLabel,
  Switch,
  Tooltip,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import {
  ApiGetAllocations,
  ApiGetVisitTimes,
  ApiGetVenueList,
  ApiGetAppliedAllocations,
  ApiPostUpdateAppliedAllocationStatus,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiGetApproveAllocationShopper,
  ApiGetAllocationCriteriaDetails,
  ApiGetAppliedBundleAllocations,
  ApiGetBundleList,
  ApiGetBundleAllocations,
  ApiPostUpdateBundleAppliedAllocationStatus,
  ApiHoldAppliedAllocation,
  ApiHoldBundleAppliedAllocation,
  ApiGetNewBundleList,
  ApiGetNewAppliedBundleAllocation,
  ApiApproveShopperBundle,
  ApiUpdateAllocationDateTime,
  ApiRejectAppliedAllocation,
  ApiPutCancelJob,
  ApiDeleteBundleAllocation,
  ApiRejectBundleAllocation,
  ApiGetAllocationWarning,
  ApiGetBundleNotes
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import Dcrage from "../OrphanAllocation/Dcrage.tsx"
import { Close, Warning, Error, Info } from "@mui/icons-material"
import dayjs, { type Dayjs } from "dayjs"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Link } from "react-router-dom"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);


interface JobAllocation {
  id: number
  allocationId: number;
  name: string
  address: string
  postalCode: string
  TradeHouse: string
  webSite: string
}

const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];

export default function ApproveAllocation() {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const dispatch = useDispatch()
  const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux));
  const [allocations, setAllocations] = useState<JobAllocation[]>([])
  const [visitTimes, setVisitTimes] = useState<any>([])
  const [venueName, setVenueName] = useState<any>([])
  const [venueNameValue, setVenueNameValue] = useState<any>(null)
  const [clientEntityList, setClientEntityList] = useState<any>([])
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)
  const [appliedAllocation, setAppliedAllocation] = useState<any>([])
  const [groupappliedAllocation, setgroupAppliedAllocation] = useState<any>([])
  const debouncedClientEntityId = useDebounce(clientEntityId, 500)
  const debouncedVenue = useDebounce(venueNameValue, 700)
  const [state, setState] = useState<any>("");
  const [infoAnchorEl, setInfoAnchorEl] = useState(null)
  const [infoData, setInfoData] = useState<any>(null)
  const [criteriabundleNote, setCriteriaBundleNote] = useState<any>()

  // Updated pagination state
  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
  const [ClientId, setClientId] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [loanData, setLoanData] = useState()
  const [datalength, setdatalength] = useState<any>()
  const [shoppers, setShoppers] = useState<any>([])
  const [allocationCriteria, setAllocationCriteria] = useState<any>()
  const [openDialog, setOpenDialog] = useState(false)
  const [issueList, setIssueList] = useState<any>([])
  const [bundleList, setbundleList] = useState<any>([])
  const [normalbundleList, setnormalbundleList] = useState<any>([])
  const [selectedBundle, setSelectedBundle] = useState<any>()
  const [selectedNormalBundle, setSelectedNormalBundle] = useState<any>()
  const [reasonforhold, setreasonforhold] = useState<any>()
  const [OpenHoldReason, setOpenHoldReason] = useState<boolean>(false)
  const [holdId, setholdId] = useState<number | string>()
  const [isActive, setIsActive] = useState(false);
  const [isActive1, setIsActive1] = useState(false);
  const [appliedData, setAppliedData] = useState<any[]>([]);
  const [bundleId, setBundlleId] = useState<any>();
  const [editedDates, setEditedDates] = useState<{ [key: number]: any }>({});
  const [editedDatesForBundle, setEditedDatesForBundle] = useState<{ [key: number]: any }>({});
  const [editedDatesForTransBundle, setEditedDatesForTransBundle] = useState<{ [key: number]: any }>({});
  const [selectedVisitTimeIds, setSelectedVisitTimeIds] = useState<{ [key: number]: number | null }>({});
  const [selectedVisitTimeIdsForBundle, setSelectedVisitTimeIdsForBundle] = useState<{ [key: number]: number | null }>({});
  const [selectedVisitTimeIdsForTransBundle, setSelectedVisitTimeIdsForTransBundle] = useState<{ [key: number]: number | null }>({});
  const [sendBundleData, setSendBundleData] = useState<any>(null)
  const [ShopperDetailsfornormalbundle, setShopperDetailsfornormalbundle] = useState<any>([])
  const [skipTrainingStatus, setSkipTrainingStatus] = useState<{ [key: number]: boolean }>({});
  const [ShopperDetailsForTransBundle, setShopperDetailsForTransBundle] = useState<any>([])

  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2])
      setClientId(Clientlist[2].clientGroupName)
    }
  }, [Clientlist])

  useEffect(() => {
    setreasonforhold('')
  }, [OpenHoldReason])

  // Updated pagination handler
  const handlePageChange = (event: any, value: any) => {
    // setCurrentPage(value)
    const jobMonth = currentDate.getMonth() + 1
    const jobYear = currentDate.getFullYear()
    handleGetAppliedAllocation(jobMonth, jobYear)
  }

  const handlePrevMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      dispatch(setDate(newDate))

      // if (!isActive && !isActive1) {
      //   handleGetAppliedAllocation(jobMonth, jobYear)
      // } else if (isActive) {
      //   GetBundleList(jobMonth, jobYear)
      // } else if (isActive1) {
      //   // Fetch normal bundle list
      //   setnormalbundleList([])
      //   GetNormalBundleList()
      // }

      if (!isActive && !isActive1) {
        handleGetAppliedAllocation(jobMonth, jobYear)
      }

      return newDate
    })
  }

  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])

  const handleHover = async (event: any, index: any, item?: any) => {
    setAnchorEl(event.currentTarget)
    try {
      const currentMonth = currentDate.getMonth() + 1
      const currentYear = currentDate.getFullYear()

      const data = `?userId=${item.userId.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`

      const response = await ApiGetShopperPopUpDetails(data)

      if (!response.status) {
        toast.error("Failed to load shopper details")
        return
      }

      if (response.data) {
        setLoanData(response.data)
      }
    } catch (error: any) {
      toast?.error(error)
      //toast.error("Error loading shopper details");
    }
  }
  const handleOpenShopperPopup = async (event: any, index: any, item?: any) => {
    setAnchorEl(event.currentTarget)
    try {
      const currentMonth = currentDate.getMonth() + 1
      const currentYear = currentDate.getFullYear()

      const data = `?userId=${item}&currentMonth=${currentMonth}&currentYear=${currentYear}`

      const response = await ApiGetShopperPopUpDetails(data)

      if (!response.status) {
        toast.error("Failed to load shopper details")
        return
      }

      if (response.data) {
        setLoanData(response.data)
      }
    } catch (error: any) {
      toast?.error(error)
      //toast.error("Error loading shopper details");
    }
  }

  const handleInfoClick = (event: any, data: any) => {
    setInfoAnchorEl(event.currentTarget)
    setInfoData(data)
  }
  const handleInfoClose = () => {
    setInfoAnchorEl(null)
    setInfoData(null)
  }

  const handleHover1 = async (event: any, index: any, item?: any) => {
    setAnchorEl(event.currentTarget)
    try {
      const currentMonth = currentDate.getMonth() + 1
      const currentYear = currentDate.getFullYear()

      const data = `?userId=${item.userId.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`

      const response = await ApiGetShopperPopUpDetails(data)

      if (!response.status) {
        toast.error("Failed to load shopper details")
        return
      }

      if (response.data) {
        setLoanData(response.data)
      }
    } catch (error) {
      //toast.error("Error loading shopper details");
    }
  }
  const handleHover2 = async (event: any, index: any, item?: any) => {
    setAnchorEl(event.currentTarget)
    try {
      const currentMonth = currentDate.getMonth() + 1
      const currentYear = currentDate.getFullYear()

      const data = `?userId=${item.userId.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`

      const response = await ApiGetShopperPopUpDetails(data)

      if (!response.status) {
        toast.error("Failed to load shopper details")
        return
      }

      if (response.data) {
        setLoanData(response.data)
      }
    } catch (error: any) {
      toast?.error(error)
      //toast.error("Error loading shopper details");
    }
  }

  const handlePopUpClose = () => {
    setAnchorEl(null)
  }

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
    if (!selectedClient?.clientGroupName) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      // console.log(res.data)
      setClientEntityList(res.data)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleNextMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      dispatch(setDate(newDate))

      // if (!isActive && !isActive1) {
      //   handleGetAppliedAllocation(jobMonth, jobYear)
      // } else if (isActive) {
      //   GetBundleList(jobMonth, jobYear)
      // } else if (isActive1) {
      //   // Fetch normal bundle list
      //   setnormalbundleList([])
      //   GetNormalBundleList()
      // }
      if (!isActive && !isActive1) {
        handleGetAppliedAllocation(jobMonth, jobYear)
      }

      return newDate
    })
  }




  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value + "-01")
    setCurrentDate(newDate)
    const jobMonth = newDate.getMonth() + 1
    const jobYear = newDate.getFullYear()
    dispatch(setDate(event.target.value))

    if (!isActive && !isActive1) {
      handleGetAppliedAllocation(jobMonth, jobYear)
    }
    // if (!isActive && !isActive1) {
    //   handleGetAppliedAllocation(jobMonth, jobYear)
    // } else if (isActive) {
    //   GetBundleList(jobMonth, jobYear)
    // } else if (isActive1) {
    //   GetNormalBundleList()
    // }
  }
  useEffect(() => {
    if (selectedDateRedux) {
      setCurrentDate(new Date(selectedDateRedux));
    }
  }, [selectedDateRedux])

  const formatDate = (date: Date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
  }

  useEffect(() => {
    const fetchData = async () => {
      // const currentDate = new Date()
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      //await ApiCallGetVenueList()
      await handleGetAppliedAllocation(jobMonth, jobYear)
      await handleGetClientList()
    }
    !selectedNormalBundle && fetchData()
    return () => { }
  }, [debouncedVenue, clientEntityId, selectedNormalBundle, isActive, isActive1, state])

  useEffect(() => {
    const fetchData = async () => {
      await handleGetVisitTimeList()
    }
    fetchData()
    return () => { }
  }, [appliedAllocation])

  const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
    let data = `?offset=0&limit=500`
    if (clientEntityId) {
      data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    } else if (selectedClient?.clientGroupName) {
      data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    }
    const res = await ApiGetVenueList(data)
    const response = res?.data.map((item: any) => ({
      label: item.venueName,
      value: item.venueId,
      state: item.state,
      entityTypeName: item.entityTypeName
    }))
    setVenueName(response)
  }

  const handleGetVisitTimeList = async (selectedVisitTime?: any) => {
    try {
      const response: any = await ApiGetVisitTimes()
      setVisitTimes(response?.data)
      // console.log("response star ", response?.data)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  useEffect(() => {
    if (debouncedClientEntityId || selectedClient?.clientGroupName) {
      ApiCallGetVenueList(debouncedClientEntityId)
    } else {
      setVenueName([])
      setVenueNameValue(null)
    }
  }, [debouncedClientEntityId, selectedClient?.clientGroupName])

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => { setSendBundleData(null); setOpen(false); setSelectedVisitTimeIds({}); setAnchorEl(null); GetNormalBundleList(); setSkipTrainingStatus({}); }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setIssueList([])
  }

  useEffect(() => {
    if (selectedClient) {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      // setCurrentPage(1) // Reset to first page when client changes
      if (!isActive && !isActive1) {
        handleGetAppliedAllocation(jobMonth, jobYear)
      } else {
        GetBundleList(jobMonth, jobYear)
      }
      setVenueNameValue(null)
      setClientEntityId(null)
    }
  }, [selectedClient])

  useEffect(() => {
    if (!isActive && !isActive1) {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      // setCurrentPage(1) // Reset to first page when client changes
      handleGetAppliedAllocation(jobMonth, jobYear)
    } else {
      setAllocations([])
    }
  }, [isActive, isActive1])

  // Updated handleGetAppliedAllocation with proper pagination
  const handleGetAppliedAllocation = async (jobMonth?: number, jobYear?: number,) => {
    setAllocations([])
    // const offset = (page - 1) * itemsPerPage
    let data = `?offset=0&limit=100&allocationStatus=shopper_applied&jobMonth=${jobMonth}&jobYear=${jobYear}${state ? `&state=${state}` : ""}`

    if (venueNameValue) data += `&venueId=${venueNameValue}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`

    if (selectedClient?.clientGroupName) {
      try {
        const res: any = await ApiGetAllocations(data)
        setdatalength(res.totalDataCount)
        const final_data = res.data?.filter((item) => item?.bundleId === null && item?.withoutVenueBundleAllocationId === null && item?.venueId !== null)
        setAllocations(final_data)

        // Set total count from API response for pagination
        if (res.totalDataCount !== undefined) {
          // setTotalCount(res.totalDataCount)
        }
      } catch (error: any) {
        console.error("Error during API call:", error)
        toast?.error(error)
      }
    }
  }
  const GetNormalBundleList = async () => {
    setnormalbundleList([])
    let data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&allocationStatus=shopper_applied`
    if (selectedClient?.clientGroupName) data += `&clientGroupName=${selectedClient?.clientGroupName}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    try {
      const res = await ApiGetBundleList(data)
      setnormalbundleList(res.data)
      setSelectedNormalBundle(null)
    } catch (error) {
      alert(error)
    }
  }
  useEffect(() => {
    if (isActive1) {
      setnormalbundleList([])

      GetNormalBundleList()
    } else {
      setnormalbundleList([])
    }
  }, [currentDate, isActive1, selectedClient, clientEntityId])

  const handleGetShopperAppliedAllocation = async (allocation: any) => {
    let data = `?offset=0&limit=10&allocationStatus=shopper_applied&status=applied&allocationId=${allocation.allocationId}`
    if (venueNameValue) data += `&venueId=${venueNameValue}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`
    try {
      const res: any = await ApiGetAppliedAllocations(data)
      setAppliedAllocation(res.data)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)

    }
  }

  const getPFshoppersforbundleAllocations = async (allocation: any) => {
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`
    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res.data?.previousMonth) {
        res.data.previousMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })
      }

      if (res.data?.futureMonth) {
        res.data.futureMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }
      setShopperDetailsfornormalbundle((prev) => ({
        ...prev,
        [allocation?.allocationId]: res.data
      }));
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleGetShopperAppliedBundleAllocation = async (allocation: any) => {
    setgroupAppliedAllocation([])
    setShopperDetailsForTransBundle([])
    // setShopperDetailsfornormalbundle([])
    const data = `?offset=0&limit=1000&withoutVenueBundleAllocationId=${allocation.bundleId}`
    try {
      await getBundleNotes(allocation.bundleId)
      const res: any = await ApiGetNewAppliedBundleAllocation(data)
      if (res?.data?.length == 0) {
        toast.info("No applications found")
        return
      }
      setAppliedData(res.data)
      // console.log("Apploed Data", appliedData);
      setBundlleId(allocation.bundleId)
      setAppliedAllocation(res.data)
      // console.log("Total Item", res.data.appliedAllocations)
      const groupedArray: any = [];

      res?.data?.forEach(item => {
        const existing = groupedArray.find(entry => entry.userId === item.userId.userId);
        if (existing) {
          existing.data.push(item);
        } else {
          groupedArray.push({
            userId: item.userId.userId,
            data: [item]
          });
        }
      });
      // groupedArray[0]?.data[0]?.allocations?.map((item: any) => {
      //   getPFshoppersforbundleAllocations(item)
      // })
      if (res?.data?.length > 0) {
        res.data.forEach((item: any) => {
          if (item?.allocations && item.allocations.length > 0) {
            item.allocations.forEach((alloc: any) => {
              getPFshoppersForTransportBundle(alloc);
            });
          }
        });
      }
      setgroupAppliedAllocation(groupedArray)
      setOpen(true)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }
  const handleGetShopperAppliedNormalBundleAllocation = async (allocation: any) => {
    // setAppliedData([])
    setgroupAppliedAllocation([])
    setShopperDetailsfornormalbundle([])
    const data = `?offset=0&limit=100&allocationStatus=applied&bundleId=${allocation.bundleId}`
    await getBundleNotes(allocation.bundleId)
    try {
      const res: any = await ApiGetAppliedBundleAllocations(data)
      if (res?.data?.length == 0) {
        toast.info("No applications found")
      }
      setAppliedAllocation(res.data[0])
      // console.log("Total Item", res.data[0].appliedAllocations)
      const groupedArray: any = [];
      if (res.data) {
        const data = res.data[0]?.appliedAllocations?.map((allocation: any) => ({
          [allocation?.appliedAllocationId]: {
            allocationId: allocation?.allocationId?.allocationId,
            venueName: allocation?.allocationId?.venueId?.venueName,
            venueAddress: allocation?.allocationId?.venueId?.address,
            tradingHours: allocation?.allocationId?.venueId?.tradingHours,
            websiteURL: allocation?.allocationId?.venueId?.websiteURL,
            clientName: allocation?.allocationId?.venueId?.clientEntityId?.entityName,
            visitDate: allocation?.selectedVisitDate?.split(" ")[0],
            visitTime: allocation?.selectedVisitTime?.visitTimeId,
            userId: allocation?.userId?.userId
          }
        }));
        setSendBundleData(data)
      }

      res.data[0].appliedAllocations.forEach(item => {
        const existing = groupedArray.find(entry => entry.userId === item.userId.userId);
        if (existing) {
          existing.data.push(item);
        } else {
          groupedArray.push({
            userId: item.userId.userId,
            data: [item]
          });
        }
      });
      groupedArray[0]?.data?.map((item: any) => {
        getPFshoppersforbundleAllocations(item?.allocationId)
      })
      setOpen(true)
      setgroupAppliedAllocation(groupedArray)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleGetApproveAllocationShopper = async (allocation: any) => {
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`
    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res.data?.previousMonth) {
        res.data.previousMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }

      if (res.data?.futureMonth) {
        res.data.futureMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }
      setShoppers(res.data)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)

    }
  }

  // console.log(appliedAllocation)

  const handleUpdateAppliedAllocation = async (shopperApplied: any, status: any, index: any) => {
    const visitDate = editedDates[index]
      ? editedDates[index].format('YYYY-MM-DD')
      : dayjs(shopperApplied.selectedVisitDate).format('YYYY-MM-DD');
    const data = {
      userId: shopperApplied.userId.userId,
      allocationId: shopperApplied.allocationId.allocationId,
      status: status,
      visitDate: visitDate,
      visitTime: selectedVisitTimeIds[index],
      modifiedBy: Number(localStorage.getItem("createdBy")),
      ...(skipTrainingStatus[index] && { isSkipTraining: true })

    }
    // console.log("Send Data", data)
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiPostUpdateAppliedAllocationStatus(data)
      handleClose()
      toast.success("Allocation Approved successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleRequestAppliedAllocation = async (shopperApplied: any, index: any) => {

    const visitDate = editedDates[index]
      ? editedDates[index].format('DD/MM/YYYY')
      : dayjs(shopperApplied.selectedVisitDate).format('DD/MM/YYYY');

    const data = {
      allocationId: shopperApplied.allocationId.allocationId,
      newVisitDate: visitDate,
      newVisitTime: shopperApplied.selectedVisitTime.visitTimeId,
      userId: shopperApplied.userId.userId

    }
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res = await ApiUpdateAllocationDateTime(data)
      handleClose()
      toast.success("Allocation Requested successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }

  }

  const handleRejectAppliedAllocation = async (shopperApplied: any) => {

    const data = `?appliedAllocationId=${shopperApplied?.appliedAllocationId}`
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res = await ApiRejectAppliedAllocation(data)
      handleClose()
      toast.success("Allocation Requested successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }

  }
  const handleBundlleShopperApprove = async (approveShopperBundle: any, status: any) => {
    const data = {
      withoutVenueBundleAllocationId: bundleId,
      userId: approveShopperBundle.userId.userId,
      status: status,
      modifiedBy: Number(localStorage.getItem("userId"))
    }
    try {
      const response = await ApiApproveShopperBundle(data)
      toast.success(response.message);
      const jobMonth = currentDate.getMonth() + 1;
      const jobYear = currentDate.getFullYear();
      GetBundleList(jobMonth, jobYear);
      handleClose()
    } catch (error) {
      console.error("Error Approving Data.", error);
      toast.error("Error Approving Data.")
    }
  }
  const handleHoldAppliedAllocation = async (shopperApplied: any) => {

    const data1 = `?userId=${holdId}&allocationId=${shopperApplied.allocationId.allocationId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldAppliedAllocation(data1, data2)
      handleClose()
      toast.success("Allocation Hold successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
    finally { setreasonforhold(''); setholdId(""); setOpenHoldReason(false); }
  }
  const handleHoldBundleAppliedAllocation = async (bundleId: any, userId: any) => {

    const data1 = `?userId=${holdId}&bundleId=${bundleId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }

    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldBundleAppliedAllocation(data1, data2)
      handleClose()
      toast.success("Allocation Hold successfully")
      // GetNormalBundleAllocations()
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
    finally { setreasonforhold(''); setOpenHoldReason(false); }
  }
  // console.log("Applied allocation", appliedAllocation)
  const handleUpdateBundleAppliedAllocation = async (bundleId: any, userId: any, status: any) => {
    const data = {
      userId: userId,
      // bundleId: bundleId,
      status: status,
      allocations: sendBundleData
        .filter((obj: any) => {
          const key = Object.keys(obj)[0];
          return obj[key]?.userId === userId;
        })
        .map((obj: any) => {
          const key = Object.keys(obj)[0];
          const val = obj[key];

          return {
            allocationId: val.allocationId,
            visitDate: val.visitDate,
            visitTime: String(val.visitTime),
            ...(val.isSkipTraining && { isSkipTraining: true })
          };
        }),
      modifiedBy: Number(localStorage.getItem("userId")),
    }
    // console.log("Send Approve Data", data)
    try {

      const res: any = await ApiPostUpdateBundleAppliedAllocationStatus(data)
      handleClose()
      toast.success("Bundle Allocation Approved successfully")
      // GetNormalBundleAllocations()
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handelInvite = (stateData: any) => {
    sessionStorage.setItem("inviteShopperState", JSON.stringify(stateData))
    const url = `/admin/allocations/Invite-Shopper`
    window.open(url, "_blank")
  }

  const handleGetAllocationCriteria = async (shopperApplied: any) => {
    // console.log(shopperApplied)
    const data = `?allocationId=${shopperApplied.allocationId}&clientEntityId=${shopperApplied.venueId.clientEntityId.clientEntityId}`
    const response = await ApiGetAllocationCriteriaDetails(data)
    setAllocationCriteria(response.data)
  }

  // console.log(allocationCriteria)

  const handleIconClick = async (shopperApplied: any) => {
    // const issues = getIssuesFromAllocationCriteria(allocationCriteria, shopperApplied.selectedVisitDate)
    console.log("Shopper Applied--->", shopperApplied)
    try {
      const data = `?allocationId=${shopperApplied.allocationId?.allocationId}&clientEntityId=${shopperApplied?.allocationId?.venueId?.clientEntityId?.clientEntityId}&shopperId=${shopperApplied?.userId?.userId}`
      const res = await ApiGetAllocationWarning(data)
      if (res?.success || res?.status) {
        setIssueList(res?.data)
        setOpenDialog(true)
      }

    } catch (error: any) {
      toast.error(error?.message)
    }

  }
  const getIssuesFromAllocationCriteria = (allocationCriteria: any, selectedDateInput: Dayjs | string): string[] => {
    const issues: string[] = []

    const selectedDate = dayjs(selectedDateInput)
    const lastJobDate = allocationCriteria?.lastJobVisitedDate ? dayjs(allocationCriteria.lastJobVisitedDate) : null

    if (allocationCriteria?.shouldBeDifferentDayFromPreviousMonth && lastJobDate) {
      if (selectedDate.format("dddd") === lastJobDate.format("dddd")) {
        issues.push("Selected day is the same weekday as the previous month's job date.")
      }
    }

    const minGap = allocationCriteria?.minDaysGapBetweenJobs
    if (minGap && lastJobDate) {
      const nextValidDate = lastJobDate.add(minGap, "day")
      if (selectedDate.isBefore(nextValidDate, "day")) {
        issues.push(
          `Selected date must be at least ${minGap} day(s) after the last visit (${lastJobDate.format("DD-MM-YYYY")}).`,
        )
      }
    }

    return issues
  }


  useEffect(() => {
    if (isActive) {
      setnormalbundleList([])
      setSelectedNormalBundle(null)
      const month = currentDate.getMonth() + 1
      const year = currentDate.getFullYear()
      GetBundleList(month, year)
    }
  }, [currentDate, isActive])

  const GetBundleList = async (month: any, year: any) => {
    setbundleList([]);
    const data = `?month=${month}&year=${year}&allocationStatus=shopper_applied`
    try {
      const res = await ApiGetNewBundleList(data)
      setbundleList(res.data)
      setSelectedBundle(null)
      setAllocations([])

    } catch (error) {
      alert(error)
    }
  }

  const GetBundleAllocations = async () => {
    if (selectedBundle) {
      const data = `?withoutVenueBundleAllocationId=${selectedBundle?.bundleId}&offset=0&limit=1000`
      try {
        const res = await ApiGetNewAppliedBundleAllocation(data)
        setAllocations(res.data)

      } catch (error) {
        alert(error)
      }
    }
  }
  // const GetNormalBundleAllocations = async () => {
  //   if (selectedNormalBundle) {
  //     const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&bundleId=${selectedNormalBundle?.bundleId}&allocationStatus=shopper_applied`
  //     try {
  //       const res = await ApiGetBundleAllocations(data)
  //       setAllocations(res.data)

  //     } catch (error) {
  //       alert(error)
  //     }
  //   }

  // }
  useEffect(() => {
    GetBundleAllocations()
  }, [selectedBundle])

  // useEffect(() => {

  //   GetNormalBundleAllocations()

  // }, [selectedNormalBundle])

  // console.log('Group ALlocation', groupappliedAllocation)

  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])


  const handleCancelJob = async (allocationId: number) => {
    const isDetelte = window.confirm("Are you sure you want to delete this allocation ?")
    if (isDetelte) {
      const data = `?allocationId=${allocationId}`
      try {
        const response: any = await ApiPutCancelJob(data)
        toast.success("Allocation Cancelled successfully!")
        const jobMonth = currentDate.getMonth() + 1
        const jobYear = currentDate.getFullYear()
        await handleGetAppliedAllocation(jobMonth, jobYear)
      } catch (error: any) {
        console.error("Error during API call:", error)
        toast.error(error)
      }
    }
  }

  useEffect(() => {
    if (appliedAllocation?.length > 0) {
      const defaults: { [key: number]: number | null } = {};
      appliedAllocation.forEach((shopperApplied: any, index: number) => {
        defaults[index] = shopperApplied?.selectedVisitTime?.visitTimeId || null;
      });
      setSelectedVisitTimeIds(defaults);
    }
  }, [appliedAllocation]);

  const handleRejectBundle = async (bundleId: any, userId: any) => {
    try {
      const data = `?bundleId=${bundleId}&userId=${userId}`
      const res = await ApiRejectBundleAllocation(data);
      toast.success(res.message);
      handleClose();
      GetNormalBundleList();
    } catch (error: any) {
      console.error("Error Rejecting Bundle.", error)
      toast.error(error)
    }
  }


  // const deleteBundle = async (allocation: any) => {
  //   try {
  //     const data = `?bundleId=${allocation?.bundleId}`
  //     const response: any = await ApiDeleteBundleAllocation(data);
  //     toast.success(response.message);
  //     await GetBundleList(currentDate.getMonth() + 1, currentDate.getFullYear())
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //   }
  // };

  const getPFshoppersForTransportBundle = async (allocation: any) => {
    if (!allocation?.venueId?.venueId) {
      return;
    }

    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`

    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res.data?.previousMonth) {
        res.data.previousMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })
      }

      if (res.data?.futureMonth) {
        res.data.futureMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }
      setShopperDetailsForTransBundle((prev) => ({
        ...prev,
        [allocation?.allocationId]: res.data
      }));
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const getBundleNotes = async (bundleId: any) => {
    try {
      const data = `?bundleId=${bundleId}`
      const res = await ApiGetBundleNotes(data)
      if(res?.status || res?.success){
          setCriteriaBundleNote(res?.data)
      }
    } catch (error:any) {
      const errorMessage =
        error ??
        error?.response?.data?.message ??
        error?.data?.message ??
        error?.message ??
        'Error On Add Or Update Admin!';

      toast.error(errorMessage);
    }
  }
  return (
    <Box className="p-2 w-100">
      <Box className="bg-white border-10 p-3">
        <Stack spacing={3}>
          <Box sx={{ width: "100%" }}>
            <Grid container className="d-flex justify-content-between mt-4 mb-2 align-items-center" gap={2}>
              <Grid flex={1}>
                <Typography className="fs-42 ">
                  Approve Allocation
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 'auto' }} sx={{ width: "fit-content" }}>
                <Stack direction="row" spacing={2} sx={{ marginRight: 0 }}>
                  {/* <FormControl size="small" sx={{ width: 300 }}>
                  <Autocomplete
                    disablePortal
                    id="mm-autocomplete"
                    options={normalbundleList}
                    value={selectedNormalBundle || null}
                    getOptionLabel={(option) => option?.bundleName}
                    isOptionEqualToValue={(option, value) => option.bundleId === value.bundleId}
                    onChange={(event, newValue: any) => {
                      setSelectedNormalBundle(newValue)
                    }}
                    // defaultValue=
                    renderInput={(params) => <TextField {...params} label="Select Bundle" />}
                    size="small"
                  />
                </FormControl> */}
                  <FormControl size="small" sx={{ width: 'fit-content', mb: 2 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isActive1}
                          onChange={(e) => {
                            if (e.target.checked && isActive) {
                              setIsActive(false);
                            }
                            setIsActive1(e.target.checked);
                          }}
                          color="primary"
                        />
                      }
                      label="Show Other Bundle"
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        m: 0,
                        width: "100%",
                        fontWeight: "bold"
                      }}
                      labelPlacement="start"
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 2, width: 'fit-content' }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isActive}
                          onChange={(e) => {
                            if (e.target.checked && isActive1) {
                              setIsActive1(false);
                            }
                            setIsActive(e.target.checked);
                          }}
                          color="primary"
                        />
                      }
                      label="Show Transport Bundle"
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        m: 0,
                        width: 'fit-contntet',
                        // width: "100%",
                        fontWeight: "bold"
                      }}
                      labelPlacement="start"
                    />
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
            <Grid container className="d-flex justify-content-between mt-4 mb-4 align-items-center" gap={2}>
              <Grid size={{ xs: 12, md: "auto" }}>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                    <Autocomplete
                      disablePortal
                      id="mm-autocomplete"
                      options={Clientlist}
                      value={selectedClient}
                      getOptionLabel={(option) => option?.clientGroupName}
                      isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                      onChange={(event, newValue: any) => {
                        // setSelectedClient(newValue)
                        dispatch(setSelectedClientGroup(newValue))
                        setClientId(newValue?.clientGroupName || null)
                        setClientEntityId(null)
                        setVenueNameValue(null)
                        setClientEntityList([])
                      }}
                      renderInput={(params) => <TextField {...params} label="Select Client" />}
                      size="small"
                    />
                  </FormControl>
                  <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                    <Autocomplete
                      disablePortal
                      id="beacon-autocomplete"
                      options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                      getOptionLabel={(option) => option?.entityName || ""}
                      onChange={(event, newValue: any) => {
                        setClientEntityId(newValue?.clientEntityId || null)
                        if (!newValue) {
                          setVenueNameValue(null)
                        }
                      }}
                      value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                      renderInput={(params) => <TextField {...params} label="Select Business" />}
                      size="small"
                    />
                  </FormControl>
                  <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                    <Autocomplete
                      disablePortal
                      id="mm-autocomplete"
                      options={venueName}
                      getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                      value={venueName.find((option: any) => option.value === venueNameValue) || null}
                      onChange={(event, newValue) => {
                        setVenueNameValue(newValue?.value)
                      }}
                      defaultValue=""
                      renderInput={(params) => <TextField {...params} label="Search Site" />}
                      size="small"
                    />
                  </FormControl>
                  {!isActive && !isActive1 && (
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={stateOptions}
                        getOptionLabel={(option: any) => `${option?.label}`}
                        value={stateOptions.find((option: any) => option.value === state) || null}
                        onChange={(event, newValue: any) => {
                          setState(newValue?.value || null)
                        }}
                        defaultValue=""
                        renderInput={(params) => <TextField {...params} label="Select State" />}
                        size="small"
                      />
                    </FormControl>
                  )}
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, md: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // marginBottom: "70px",
                  }}
                >
                  <IconButton onClick={handlePrevMonth}>
                    <ChevronLeftIcon />
                  </IconButton>
                  <Box sx={{ display: "flex", alignItems: "center", mx: 0 }}>
                    <input
                      type="month"
                      value={formatDate(currentDate)}
                      onChange={handleDateChange}
                      className="primary-color"
                      style={{
                        border: "none",
                        background: "none",
                        fontSize: "1.25rem",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    />
                  </Box>
                  <IconButton onClick={handleNextMonth}>
                    <ChevronRightIcon />
                  </IconButton>
                </Box>
              </Grid>

            </Grid>
          </Box>
          <Grid
            container
            spacing={4}
            className="mt-0"
            style={{
              gap: "20px",
              // paddingRight: "32px",
            }}
          >

            {(!isActive && !isActive1 && allocations.length > 0) && allocations?.map((allocation: any, index) => (
              <Grid
                size={{ xs: 12, md: 6 }}
                sx={{
                  padding: "0px",
                  boxShadow: "none",
                  maxWidth: "100%",
                  width: "100%",
                }}
                key={index}
              >
                {allocation.venueId != null && (
                  <Card className="min-border-color w-100" style={{ boxShadow: "none", }}>
                    <CardContent className="w-100">

                      <Box
                        className="w-100"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: 'start',
                          // border:"2px solid red"
                        }}
                        flexDirection={{ xs: "column", md: "row" }}
                      >

                        <div style={{ flexGrow: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "0px" }}>
                            <img
                              src={allocation?.venueId?.logoUrl}
                              alt=""
                              style={{ width: "50px", maxWidth: "50px", borderRadius: 8, marginBottom: 12 }}
                            />
                            <Typography variant="h6" gutterBottom>
                              {allocation?.venueId?.venueName}
                            </Typography>
                            {allocation?.venueId?.clientEntityId?.entityTypeId?.entityTypeName && (
                              <Typography gutterBottom className="p-1" style={{ border: "1px solid black", borderRadius: "7px", backgroundColor: "#ADB792", color: "white", fontSize: "10px" }}>
                                {allocation?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}
                              </Typography>
                            )}
                            {/* {allocation?.venueId?.shopTypeId?.shopTypeName && (
                              <Typography gutterBottom className="p-1" style={{ border: "1px solid black", borderRadius: "7px", backgroundColor: "#ADB792", color: "white", fontSize: "10px" }}>
                                {allocation?.venueId?.shopTypeId?.shopTypeName}
                              </Typography>
                            )} */}
                          </div>
                          <Typography sx={{ wordBreak: 'break-word' }}>
                            {" "}
                            <b>Address:</b> {allocation?.venueId?.address}
                            {/* {allocation?.venueId?.city}  {allocation?.venueId?.suburb ? `,${allocation?.venueId?.suburb},` : ''} {allocation?.venueId?.state} {allocation?.venueId?.postalCode} */}
                          </Typography>
                          {/* <Typography>
                          <b>Postcode:</b> {allocation?.venueId?.postalCode}
                        </Typography> */}
                          <Typography sx={{ wordBreak: 'break-word' }}>
                            <b>Trading Hours:</b> {allocation?.venueId?.tradingHours}
                          </Typography>
                          <Typography sx={{ wordBreak: 'break-word' }}>
                            <b>Website:</b> {allocation?.venueId?.websiteURL}
                          </Typography>
                          <Typography sx={{ wordBreak: 'break-word' }}>
                            <b>Clientname:</b> {allocation?.venueId?.clientEntityId?.entityName}
                          </Typography>
                        </div>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            // marginLeft: "16px",
                            width: { xs: "100%", md: "auto" },
                            marginTop: { xs: 2, md: 0 }
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            sx={{ marginBottom: "8px", width: { md: "170px", xs: "100%" } }}
                            onClick={async () => {
                              await handleGetVisitTimeList(allocation)
                              await handleGetShopperAppliedAllocation(allocation)
                              await handleGetApproveAllocationShopper(allocation)
                              await handleGetAllocationCriteria(allocation)
                              handleClickOpen()
                            }}
                          >
                            View Applications
                          </Button>
                          <Link
                            to={`/admin/allocations/Invite-Shopper/${allocation?.allocationId}`}
                            // variant="contained"
                            // color="primary"
                            // size="small"
                            className="table-row-background p-2 text-center link-btn"
                            style={{ width: '100%', maxWidth: '170px' }}
                          // onClick={() => handelInvite(allocation)}
                          >
                            Invite Shopper
                          </Link>
                          <Button
                            variant="outlined"
                            // color="danger"
                            size="small"
                            sx={{ background: "#FF00001A", color: "#FF0000", borderColor: "#FF0000", width: { md: "170px", xs: "100%", whiteSpace: "nowrap" } }}

                            className="mt-2"
                            onClick={() => handleCancelJob(allocation?.allocationId)}
                          >
                            Delete Allocation
                          </Button>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            ))}
            {isActive && bundleList?.map((Item: any, index: any) => (
              <Grid
                size={{ xs: 12, md: 6 }}
                sx={{
                  padding: "0px",
                  boxShadow: "none",
                  maxWidth: "100%",
                  width: "100%",
                }}
                key={index}
              >
                <Card className="min-border-color" style={{ boxShadow: "none" }} sx={{ padding: "16px" }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      flexDirection={{ xs: "column", md: "row" }}
                    >
                      <Box sx={{ flexGrow: 1, alignItems: { xs: "center", md: "auto" }, justifyContent: { xs: "center", md: "auto" }, display: { xs: "flex", md: "block" } }}>
                        <Typography variant="h6" gutterBottom>
                          {Item?.bundleName}
                        </Typography>
                        {/* <Typography>
                          {" "}
                          <b>Address:</b> {allocation?.venueId?.address}
                        </Typography>
                        <Typography>
                          <b>Postcode:</b> {allocation?.venueId.postalCode}
                        </Typography>
                        <Typography>
                          <b>Trade House:</b> {allocation?.venueId.tradingHours}
                        </Typography>
                        <Typography>
                          <b>WebSite:</b> {allocation?.venueId.websiteURL}
                        </Typography> */}
                      </Box>
                      <div

                        style={{
                          width: 'fit-content',
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "16px",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ marginBottom: "8px", width: "170px" }}
                          onClick={() => {
                            // handleGetVisitTimeList(allocation)
                            handleGetShopperAppliedBundleAllocation(Item)
                            // handleClickOpen()
                            // handleGetApproveAllocationShopper(allocation)
                            // handleGetAllocationCriteria(allocation)
                          }}
                        >
                          View Applications
                        </Button>
                        {/* <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ width: "170px" }}
                        // onClick={() => handelInvite(Item)}
                        >
                          Invite Shopper
                        </Button> */}
                      </div>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {isActive1 && normalbundleList?.map((Item: any, index: any) => (
              <Grid
                size={{ xs: 12, md: 6 }}
                sx={{
                  padding: "0px",
                  boxShadow: "none",
                  maxWidth: "100%",
                  width: "100%",
                }}
                key={index}
              >
                <Card className="min-border-color" style={{ boxShadow: "none" }} sx={{ padding: "16px" }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: { xs: "column", md: "row" }
                      }}
                    >
                      <Box width={'100%'} sx={{ overflow: 'auto', alignItems: { xs: "center", md: "auto" }, justifyContent: { xs: "center", md: "auto" }, display: { xs: "flex", md: "block" } }}>
                        <Typography variant="h6" gutterBottom>
                          {Item?.bundleName}
                        </Typography>
                        {/* <Typography>
                          {" "}
                          <b>Address:</b> {allocation?.venueId?.address}
                        </Typography>
                        <Typography>
                          <b>Postcode:</b> {allocation?.venueId.postalCode}
                        </Typography>
                        <Typography>
                          <b>Trade House:</b> {allocation?.venueId.tradingHours}
                        </Typography>
                        <Typography>
                          <b>WebSite:</b> {allocation?.venueId.websiteURL}
                        </Typography> */}
                      </Box>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "16px",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ marginBottom: "8px", width: "170px" }}
                          onClick={() => {
                            // handleGetVisitTimeList(allocation)
                            handleGetShopperAppliedNormalBundleAllocation(Item)
                            // handleClickOpen()

                            // handleGetApproveAllocationShopper(allocation)
                            // handleGetAllocationCriteria(allocation)
                          }}
                        >
                          View Applications
                        </Button>
                        {/* <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ width: "170px" }}
                        // onClick={() => handelInvite(Item)}
                        >
                          Invite Shopper
                        </Button> */}
                      </div>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}

          </Grid>
        </Stack>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handlePopUpClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {loanData ? <Dcrage handleClose={handleClose} loanData={loanData} /> : null}
        </Popover>
        <Popover
          open={Boolean(infoAnchorEl)}
          anchorEl={infoAnchorEl}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Box sx={{ p: 2, maxWidth: 300 }}>
            <Typography sx={{ wordBreak: 'break-word' }}><b>Venue:</b> {infoData?.venueName}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}><b>Address:</b> {infoData?.venueAddress}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}><b>Trading Hours:</b> {infoData?.tradingHours}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}><b>Website:</b> {infoData?.websiteURL}</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}><b>Clientname:</b> {infoData?.clientName}</Typography>
          </Box>
        </Popover>

        <Dialog className="ApproveAllocation new-popup border-20"
          sx={{
            "& .MuiDialog-paper": {
              width: "100vw",
              maxWidth: "1400px !important",
              height: "auto",
              maxHeight: "100vh",
            },
          }} open={open} onClose={handleClose}>
          <DialogContent className="dialog-content m-0 mx-auto" sx={{ width: "100% !important", maxWidth: "1390px !important" }}>
            <div
              style={{
                display: "flex ",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <DialogTitle className="dialog-title">Approve applications</DialogTitle>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                X
              </div>
            </div>

            {(!isActive && !isActive1) ? (
              <div style={{ display: "flex" }}>
                <div className="previous-shoppers table-row-background">
                  <h2 className="previous-shoppers__title">Previous Shoppers</h2>

                  <div className="previous-shoppers__grid">
                    {shoppers?.previousMonth?.map((shopper: any, index: any) => (
                      <div className="previous-shoppers__item" key={index}>
                        <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                        <div className="previous-shoppers__name">{shopper?.shopperFirstName} {shopper?.shopperLastName}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="previous-shoppers table-row-background">
                  <h2 className="previous-shoppers__title">Future Shoppers</h2>

                  <div className="previous-shoppers__grid d-flex flex-wrap">
                    {shoppers?.futureMonth?.map((shopper: any, index: any) => (
                      <div className="previous-shoppers__item" key={index}>
                        <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                        <div className="previous-shoppers__name">{shopper?.shopperFirstName} {shopper?.shopperLastName}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

            <Grid size={12}>
              <Typography variant="h6"> <b>Notes:</b></Typography>
              <Grid container spacing={2}>
                {allocationCriteria?.adminVenueNote?.map((item: any, index: number) => (
                  <Grid size={12} className='p-1' borderBottom={'1px dashed '} key={index}>
                    <Grid container justifyContent={'space-between'} spacing={2}>
                      <Grid size={12} className='d-flex' gap={1} justifyContent={'end'}>
                        <Typography variant="caption">
                          {dayjs
                            .tz(item?.modifiedOn || item?.createdOn, "Australia/Sydney")
                            .local()
                            .format("DD-MM-YYYY HH:mm")}
                        </Typography>
                        <Typography variant="caption">({item?.createdByFirstName}{item?.createdByLastName})</Typography>
                      </Grid>
                      <Grid size={'grow'}>
                        <Typography>{item?.notes}</Typography>
                      </Grid>
                      {/* {item?.createdBy == localStorage.getItem('userId') && (
                        <>
                          <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { setSelectedNoteId(item?.adminVenueNoteId); setSiteNote(item?.notes); setOpenAddNote(true) }}>
                            <EditOutlined sx={{ color: '#ADB792' }} />
                          </Grid>
                          <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { handleDeleteSiteNote(item?.adminVenueNoteId) }}>
                            <DeleteOutlined sx={{ color: 'red' }} />
                          </Grid>
                        </>
                      )} */}
                    </Grid>
                  </Grid>

                ))}
              </Grid>
            </Grid>

            {allocationCriteria?.notes && !isActive && !isActive1 && (
              <Box className='d-flex align-items-center' sx={{ gap: 1 }}>
                <Typography variant="h6"> <b>Criteria Notes:</b></Typography>
                <Typography variant="h6"> {allocationCriteria?.notes}</Typography>
              </Box>
            )}
            {(isActive ||isActive1 )&& (
              <Box className='' sx={{ gap: 1 }}>
                <Typography variant="h6"> <b>Criteria Notes:</b></Typography>
              {criteriabundleNote?.map((item:any)=>(
                <Typography variant="body1"> {item?.notes}</Typography>
              ))}
              </Box>
            )}
            <div className="applications">
              {!isActive && !isActive1 && (
                <div className="applications__header table-row-background">
                  {/* <div className="applications__header-cell">Delete</div> */}
                  <div className="applications__header-cell">Shopper Name</div>
                  <div className="applications__header-cell text-start">Date</div>
                  <div className="applications__header-cell">Time</div>
                  <div className="applications__header-cell">Skip Training?</div>
                  <div className="applications__header-cell">Issues</div>
                  <div className="applications__header-cell">Action</div>
                </div>)}


              {(!isActive && !isActive1 && appliedAllocation?.length > 0) && appliedAllocation?.map((shopperApplied: any, index: any) => (
                <>
                  <div className="applications__row" key={index}>
                    {/* <div className="applications__cell">
                      <button className="delete-button">X</button>
                    </div> */}
                    <div className="applications__cell " style={{ cursor: "pointer" }}>
                      <span
                        className="shopper-badge table-row-background"
                        onClick={(e) => {
                          handleHover(e, index, shopperApplied)
                        }}
                      >
                        {shopperApplied.userId.firstName} {shopperApplied.userId.lastName}
                      </span>
                    </div>
                    {/* <div
                      className="applications__cell"
                      style={{
                        background: "white",
                        textAlign: "center",
                        borderRadius: "5px",
                      }}
                    >
                      {new Date(shopperApplied.selectedVisitDate).toLocaleDateString("en-GB")}
                    </div> */}
                    <div className="applications__cell text-center">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={editedDates[index] || dayjs(shopperApplied.selectedVisitDate)}
                          format="DD/MM/YYYY"
                          onChange={(newValue) => {
                            setEditedDates((prev) => ({
                              ...prev,
                              [index]: newValue
                            }));
                          }}
                          minDate={dayjs(shopperApplied.selectedVisitDate).startOf("month")}
                          maxDate={dayjs(shopperApplied.selectedVisitDate).endOf("month")}
                          slotProps={{
                            textField: {
                              size: 'small',
                              sx: {
                                background: 'white',
                                borderRadius: '5px',
                                width: '130px'
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* <div className="applications__cell">{shopperApplied.selectedVisitTime.visitTimeInformation}</div> */}
                    {/* visitTimes */}
                    <div className="applications__cell">
                      <Autocomplete
                        options={visitTimes}
                        getOptionLabel={(option: any) => option.visitTimeInformation}
                        value={
                          !selectedVisitTimeIds[index] ?
                            visitTimes.find((v: any) => v.visitTimeId === shopperApplied.selectedVisitTime.visitTimeId) || null :
                            visitTimes.find((v: any) => v.visitTimeId === selectedVisitTimeIds[index]) || null}
                        onChange={(event, newValue: any) => {
                          setSelectedVisitTimeIds((prev) => ({
                            ...prev,
                            [index]: newValue ? newValue.visitTimeId : null
                          }));
                        }}

                        renderInput={(params) => <TextField {...params} label="Visit Time" size="small" fullWidth sx={{
                          // width:'fit-content',
                          minWidth: '300px',
                          "& .MuiInputBase-root": {
                            whiteSpace: "nowrap", // allow wrapping
                            overflow: "visible",  // don't hide overflow text
                          },
                          "& .MuiAutocomplete-input": {
                            textOverflow: "unset", // prevent text truncation
                          },
                        }} />}
                      />
                    </div>

                    <div className="applications__cell">
                      <Checkbox
                        checked={skipTrainingStatus[index] || false}
                        onChange={(e) => {
                          setSkipTrainingStatus((prev) => ({
                            ...prev,
                            [index]: e.target.checked
                          }));
                        }}
                      />
                    </div>
                    <div className="applications__cell">
                      <IconButton
                        size="small"
                        className="iconColor"
                        onClick={() => {
                          handleIconClick(shopperApplied)
                          // handleIconClick(shopperApplied)
                        }}
                      >
                        <Warning
                          sx={{
                            color: "gray",
                            cursor: "pointer",
                          }}
                        />
                      </IconButton>
                    </div>
                    <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved", index)}
                      >
                        Approve
                      </Button>
                      <Tooltip
                        title={
                          shopperApplied?.isHold
                            ? shopperApplied?.holdReason || "NO Reason added"
                            : ""
                        }
                        arrow
                      >
                        <span>
                          <Button
                            className="action-button action-button--approve table-row-background"
                            disabled={shopperApplied?.isHold}
                            onClick={() => { setOpenHoldReason(true); setholdId(shopperApplied.userId.userId) }}
                          >
                            Hold
                          </Button>
                        </span>
                      </Tooltip>
                    </div>
                    {/* <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleRequestAppliedAllocation(shopperApplied, index)}
                      >
                        Request
                      </Button>
                    </div> */}
                    <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleRejectAppliedAllocation(shopperApplied)}
                      >
                        Reject
                      </Button>
                    </div>
                  </div>

                  <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false); setholdId("") }}>
                    <DialogContent>
                      <TextField
                        required

                        className='p-0'
                        sx={{
                          width: '300px',
                          ".MuiOutlinedInput-input ": {
                            padding: '10px'
                          },
                          ".MuiInputLabel-root": {
                            top: '-6px'
                          }
                        }}
                        value={reasonforhold}
                        onChange={(e) => { setreasonforhold(e.target.value) }}
                        id="outlined-required"
                        label="Reason"
                      />
                      <Button sx={{ color: 'white' }} className="d-block mt-2  mx-auto action-button action-button--approve table-row-background"
                        onClick={() => { (reasonforhold.length > 0) ? handleHoldAppliedAllocation(shopperApplied) : alert("Reason is required") }}>
                        Submit
                      </Button>
                    </DialogContent>
                  </Dialog>
                </>
              ))}
              {isActive && !selectedNormalBundle && (
                <div className="applications__header2 table-row-background" style={{ justifyContent: "space-between !important" }}>
                  {/* <div className="applications__header-cell">Delete</div> */}
                  <div className="applications__header-cell text-center">Shopper Name</div>
                  <div className="applications__header-cell text-center">Date</div>
                  <div className="applications__header-cell text-center">Time</div>
                  <div className="applications__header-cell text-center">Site</div>
                  <div className="applications__header-cell text-center">Last Shopper</div>
                  <div className="applications__header-cell text-center">2nd Last Shopper</div>
                  <div className="applications__header-cell text-center">Future Shopper</div>
                  <div className="applications__header-cell text-center">Action</div>
                </div>)}
              {isActive && !selectedNormalBundle && appliedData?.map((Card, index) => (
                <>
                  <div className="applications__row2" key={index}>
                    {/* <div className="applications__cell">
                      <button className="delete-button">X</button>
                    </div> */}
                    <div className="applications__cell text-center" style={{ cursor: "pointer" }}>
                      <span
                        className="shopper-badge table-row-background "
                        onClick={(e) => {
                          handleHover2(e, index, Card)
                        }}
                      >
                        {Card?.userId?.firstName} {Card?.userId?.lastName}
                      </span>
                    </div>
                    <div
                      className="applications__cell text-center"
                      style={{
                        background: "white",
                        textAlign: "center",
                        borderRadius: "5px",
                      }}
                    >
                      {new Date(Card?.selectedVisitDate).toLocaleDateString("en-GB")}
                    </div>
                    {/* <div className="applications__cell text-center py-0 my-0" >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker sx={{ width: "" }}
                          value={editedDatesForTransBundle[index] || dayjs(Card.selectedVisitDate)}
                          format="DD/MM/YYYY"
                          onChange={(newValue) => {
                            setEditedDatesForTransBundle((prev) => ({
                              ...prev,
                              [index]: newValue
                            }));
                          }}
                          minDate={dayjs(Card.selectedVisitDate).startOf("month")}
                          maxDate={dayjs(Card.selectedVisitDate).endOf("month")}
                          slotProps={{
                            textField: {
                              size: 'small',
                              sx: {
                                background: 'white',
                                borderRadius: '5px',
                                width: '160px'
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div> */}
                    <div className="applications__cell text-center">{Card?.selectedVisitTime?.visitTimeInformation}</div>
                    {/* <div className="applications__cell py-0 my-0">
                      <Autocomplete
                        options={visitTimes}
                        getOptionLabel={(option: any) => option.visitTimeInformation}
                        value={
                          !selectedVisitTimeIdsForTransBundle[index] ?
                            visitTimes.find((v: any) => v.visitTimeId === Card.selectedVisitTime.visitTimeId) || null :
                            visitTimes.find((v: any) => v.visitTimeId === selectedVisitTimeIdsForTransBundle[index]) || null}
                        onChange={(event, newValue: any) => {
                          setSelectedVisitTimeIdsForTransBundle((prev) => ({
                            ...prev,
                            [index]: newValue ? newValue.visitTimeId : null
                          }));
                        }}

                        renderInput={(params) => <TextField {...params} label="Visit Time" size="small" fullWidth sx={{
                          minWidth: '300px',
                          "& .MuiInputBase-root": {
                            whiteSpace: "nowrap",
                            overflow: "visible",
                          },
                          "& .MuiAutocomplete-input": {
                            textOverflow: "unset",
                          },
                        }} />}
                      />
                    </div> */}
                    <div className="applications__cell text-center">
                      {Card?.allocations?.[0]?.venueId?.venueName || 'N/A'}
                    </div>
                    <div className="applications__cell text-center">
                      {Card?.allocations?.[0]?.venueId?.venueId ? (
                        `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[0]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[0]?.shopperLastName}` || '-'
                      ) : '-'}
                    </div>

                    <div className="applications__cell text-center">
                      {Card?.allocations?.[0]?.venueId?.venueId ? (
                        `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[1]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[1]?.shopperLastName}` || '-'
                      ) : '-'}
                    </div>

                    <div className="applications__cell text-center">
                      {Card?.allocations?.[0]?.venueId?.venueId ? (
                        `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.futureMonth?.[0]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.futureMonth?.[0]?.shopperLastName}` || '-'
                      ) : '-'}
                    </div>
                    <div className="applications__cell text-center">
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleBundlleShopperApprove(Card, "approved")}
                      >
                        Approve
                      </Button>
                      {/* <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => { setOpenHoldReason(true) }}
                      >
                        Hold
                      </Button> */}
                    </div>
                  </div>
                </>

              ))}
              {isActive1 && normalbundleList && groupappliedAllocation?.map((Card, index) => (
                <>
                  <Box className='border my-3 px-3  py-2' borderRadius='20px' >
                    <div style={{ borderBottom: '1px solid #a3a3a3' }} className="applications__cell applications__actions d-flex justify-content-between">
                      <Typography fontWeight='bold' variant="h6" sx={{ cursor: "pointer" }} onClick={(e) => {
                        handleHover1(e, index, Card.data[0])
                      }}
                      >
                        {Card.data[0].userId.firstName} {Card.data[0].userId.lastName}
                      </Typography>
                      <Box className='d-flex' gap={2}>
                        <Button
                          className="action-button action-button--approve table-row-background"
                          onClick={() => handleUpdateBundleAppliedAllocation(appliedAllocation.bundleId, Card.userId, "approved")}
                        >
                          Approve
                        </Button>
                        <Tooltip
                          title={
                            Card?.data[0]?.isHold
                              ? Card?.data[0]?.holdReason || "NO Reason added"
                              : ""
                          }
                          arrow
                        >
                          <span>
                            <Button
                              disabled={Card?.data[0]?.isHold}
                              className="action-button action-button--approve table-row-background"
                              onClick={() => { setOpenHoldReason(true); setholdId(Card.userId) }}
                            >
                              Hold
                            </Button>
                          </span>
                        </Tooltip>
                        <Button
                          className="action-button action-button--approve table-row-background"
                          onClick={() => handleRejectBundle(appliedAllocation.bundleId, Card.userId,)}
                        >
                          Reject
                        </Button>
                      </Box>
                    </div>
                    <div className="applications__header2 py-0 mt-2 table-row-background">
                      <div className="applications__header-cell text-center" style={{ width: '160px' }}>Date</div>
                      <div className="applications__header-cell text-center" style={{ width: '350px' }}>Time</div>
                      <div className="applications__header-cell">Site</div>
                      <div className="applications__header-cell text-center">Skip Training?</div>
                      <div className="applications__header-cell text-center">Info</div>
                      <div className="applications__header-cell text-center">Issues</div>
                      <div className="applications__header-cell text-center">Last Shopper</div>
                      <div className="applications__header-cell text-center">2nd Last Shopper</div>
                      <div className="applications__header-cell text-center">Future Shopper</div>
                    </div>

                    {Card.data.map((shopperApplied: any, index: number) => {
                      const key = shopperApplied?.appliedAllocationId;

                      const found = sendBundleData?.find((item: any) => item[key]);
                      return (
                        <div className="applications__row2 mt-2 gap-2" key={index}>
                          {/* <div
                          className="applications__cell py-0 my-0"
                          style={{
                            background: "white",
                            textAlign: "center",
                            borderRadius: "5px",
                          }}
                        >
                          {new Date(shopperApplied.selectedVisitDate).toLocaleDateString("en-GB")}
                        </div> */}
                          <div className="applications__cell text-center py-0 my-0" >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker sx={{ width: "" }}
                                value={sendBundleData && dayjs(found?.[key]?.visitDate)}
                                format="DD/MM/YYYY"
                                onChange={(newValue) => {
                                  const key = shopperApplied?.appliedAllocationId;

                                  setSendBundleData(prev =>
                                    prev.map(item =>
                                      item[key]
                                        ? {
                                          ...item,
                                          [key]: {
                                            ...item[key],
                                            visitDate: newValue
                                              ? dayjs(newValue).format("YYYY-MM-DD")
                                              : null
                                          }
                                        }
                                        : item
                                    )
                                  );
                                }}

                                minDate={dayjs(shopperApplied.selectedVisitDate).startOf("month")}
                                maxDate={dayjs(shopperApplied.selectedVisitDate).endOf("month")}
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    sx: {
                                      background: 'white',
                                      borderRadius: '5px',
                                      width: '160px'
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                          {/* <div className="applications__cell py-0 my-0">{shopperApplied.selectedVisitTime.visitTimeInformation}</div> */}
                          <div className="applications__cell text-center py-0 my-0 mr-4">
                            <Autocomplete
                              options={visitTimes}
                              getOptionLabel={(option: any) => option.visitTimeInformation}
                              value={
                                visitTimes.find((v: any) => v.visitTimeId == found?.[key]?.visitTime) || null

                              }
                              onChange={(event, newValue: any) => {
                                setSendBundleData((prev: any) =>
                                  prev.map((item: any) =>
                                    item[key]
                                      ? {
                                        ...item,
                                        [key]: {
                                          ...item[key],
                                          visitTime: newValue ? newValue.visitTimeId : null,
                                        },
                                      }
                                      : item
                                  )
                                );
                              }}

                              renderInput={(params) => <TextField {...params} label="Visit Time" size="small" fullWidth sx={{
                                minWidth: '300px',
                                "& .MuiInputBase-root": {
                                  whiteSpace: "nowrap",
                                  overflow: "visible",
                                },
                                "& .MuiAutocomplete-input": {
                                  textOverflow: "unset",
                                },
                              }} />}
                            />
                          </div>
                          <div className="applications__cell py-0 my-0 mr-4" style={{ width: "fit-content" }} >
                            {found?.[key]?.venueName}
                          </div>
                          <div className="applications__cell text-center py-0 my-0">   {/* NEW */}
                            <Checkbox
                              checked={found?.[key]?.isSkipTraining || false}
                              onChange={(e) => {
                                setSendBundleData((prev: any) =>
                                  prev.map((item: any) =>
                                    item[key]
                                      ? { ...item, [key]: { ...item[key], isSkipTraining: e.target.checked } }
                                      : item
                                  )
                                );
                              }}
                            />
                          </div>
                          <div className="applications__cell text-center py-0 my-0">   {/* NEW */}
                            <IconButton size="small" onClick={(e) => handleInfoClick(e, found?.[key])}>
                              <Info sx={{ color: "gray", cursor: "pointer" }} />
                            </IconButton>
                          </div>
                          <div className="applications__cell text-center py-0 my-0">   {/* NEW */}
                            <IconButton
                              size="small"
                              className="iconColor"
                              onClick={() => handleIconClick(shopperApplied)}
                            >
                              <Warning sx={{ color: "gray", cursor: "pointer" }} />
                            </IconButton>
                          </div>
                          {ShopperDetailsfornormalbundle?.[found?.[key]?.allocationId]?.previousMonth?.map((item: any, index: number) => {
                            if (index > 1) return;
                            return (
                              <div className="applications__cell text-center py-0 my-0 ml-4"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                  handleOpenShopperPopup(e, index, item?.shopperId)
                                }}
                              >
                                {item?.shopperFirstName} {item?.shopperLastName}
                              </div>
                            )
                          })}
                          {ShopperDetailsfornormalbundle?.[found?.[key]?.allocationId]?.futureMonth?.map((item: any, index: number) => {
                            if (index > 0) return;
                            return (<div className="applications__cell text-center py-0 my-0"
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => {
                                handleOpenShopperPopup(e, index, item?.shopperId)
                              }}
                            >
                              {item?.shopperFirstName} {item?.shopperLastName}
                            </div>
                            )
                          })}

                          {/* <div className="applications__cell text-center py-0 my-0">
                            <IconButton
                              size="small"
                              className="iconColor"
                              onClick={() => {
                                handleIconClick(shopperApplied)
                              }}
                            >
                              <Warning
                                sx={{
                                  color: "red",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </div> */}
                        </div>

                      )
                    })}
                    <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false) }}>
                      <DialogContent>
                        <TextField
                          required

                          className='p-0'
                          sx={{
                            width: '300px',
                            ".MuiOutlinedInput-input ": {
                              padding: '10px'
                            },
                            ".MuiInputLabel-root": {
                              top: '-6px'
                            }
                          }}
                          value={reasonforhold}
                          onChange={(e) => { setreasonforhold(e.target.value) }}
                          id="outlined-required"
                          label="Reason"
                        />
                        <Button sx={{ color: 'white' }} className="d-block mt-3 mx-auto action-button action-button--approve table-row-background"
                          onClick={() => { (reasonforhold.length > 0) ? handleHoldBundleAppliedAllocation(appliedAllocation.bundleId, holdId) : alert("Reason is requierd") }}>
                          Submit
                        </Button>
                      </DialogContent>
                    </Dialog>
                  </Box>
                </>
              ))}
            </div>
          </DialogContent >
        </Dialog>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              pb: 1,
            }}
          >
            <Warning sx={{ color: "error.main" }} />
            <Typography variant="h6" component="span">
              Allocation Issues
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ ml: "auto" }} size="small">
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {issueList?.warnings?.length > 0 ? (
              <List dense>
                {issueList?.warnings.map((issue: any, index: number) => (
                  <ListItem key={index} sx={{ px: 0 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <Error sx={{ color: "error.main", fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={issue}
                      primaryTypographyProps={{
                        variant: "body2",
                        color: "text.primary",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 3,
                }}
              >
                <Typography variant="body1" color="success.main">
                  ✅ No issues found with the current allocation criteria.
                </Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Updated Pagination - now uses totalCount from API */}
      </Box>
    </Box>
  )
}
